import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { useLocations } from "@/Common/hooks/Location/useLocations";
import { useCommissionCyclesData } from "@/Washouts/hooks/common/useCommissionCyclesData";
import moment from "moment";

export const useQueryParams = () => {
	const [searchParams] = useSearchParams();

	const locPrefix = searchParams.get("loc")?.trim();
	const cycleTitle = searchParams.get("cycle")?.trim();
	const cycleYear = searchParams.get("year")?.trim();

	const { locations = [], isLoading: isLoadingLocations } = useLocations();
	const { commissionCycles = [], isLoading: isLoadingCycles } = useCommissionCyclesData();

	const location = useMemo(() => {
		if (!locPrefix) {
			return undefined;
		}
		return locations?.find((location) => location.prefix === locPrefix);
	}, [locPrefix, locations]);

	const commissionCycle = useMemo(() => {
		if (!cycleTitle || !cycleYear) {
			return undefined;
		}
		return commissionCycles.find((cycle) => {
			const cycleYearValue = moment.utc(cycle.startDate).format("YYYY");
			return cycle.title === cycleTitle && cycleYearValue === cycleYear;
		});
	}, [commissionCycles, cycleTitle, cycleYear]);

	return {
		location,
		commissionCycle,
		isLoading: isLoadingLocations || isLoadingCycles,
	};
};
